import React from 'react';
import { Outlet } from 'react-router-dom';

const IsosPage = () => <Outlet />;

export default IsosPage;
